import React from "react"
import { graphql } from "gatsby"

import * as styles from "./recruiter.module.scss"

const RecruiterItem = ({ contactLabel, contactUrl, phone1, phone2, siteLabel, siteUrl }) => {
  return (
    <tr>
      <td>
        <a href={siteUrl}>{siteLabel}</a>
      </td>
      <td>
        <strong>{phone1}</strong>
        { phone2 &&
        <span>{phone2}</span>
        }
      </td>
      <td>
        <a href={contactUrl}>{contactLabel}</a>
      </td>
    </tr>
  )
}

const Recruiter = ({ recruiterItem }) => {
  return (
    <section>
      <div className={styles['inner']}>
        <table cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              <th>Military Service Website</th>
              <th>Phone Number</th>
              <th>Email or Contact Form</th>
            </tr>
          </thead>
          <tbody>
            {recruiterItem?.map(item => <RecruiterItem {...item} key={item.id} />)}
          </tbody>
        </table>
      </div>
    </section>
  )
}

export default Recruiter

export const query = graphql`
fragment RecruiterData on STRAPI__COMPONENT_SUPERCUSTOM_RECRUITER {
  recruiterItem {
    id
    contactLabel
    contactUrl
    phone1
    phone2
    siteLabel
    siteUrl
  }
}
`
